import moment from 'moment';
import template from './komentarWidget.html';

class KomentarWidgetController {
    constructor(DS) {
        this.datastore = () => DS;
    }

    $onInit() {
        this.komentari = [];
        this.day = moment();
    }

    $onChanges() {
        this.fetch();
    }

    getDayOfWeek(day) {
        return moment(day).format('ddd');
    }

    fetch() {
        const DS = this.datastore();
        const Komentar = DS.definitions['Komentar'];

        Komentar.findAll({ created_at: this.day.format('YYYY-MM-DD') }, { bypassCache: true }).then(response => {
            this.komentari = [...response];
        });
    }
}

KomentarWidgetController.$inject = ['DS'];

const KomentarWidgetComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: KomentarWidgetController,
    controllerAs: 'vm',
    bindings: {
        day: '<'
    }
};

export { KomentarWidgetComponent };
export { KomentarWidgetController };



// WEBPACK FOOTER //
// ./app/components/dashboard/komentarWidget.component.js